import Tabs from "../Tabs/Tabs";
import { ReactNode } from "react";
import { Tab } from "../../types/tabs";

interface OrderOfMeritPageTabsProps {
  tabs: Tab[];
  children: ReactNode;
}

const OrderOfMeritPageTabs = ({
  tabs,
  children,
}: OrderOfMeritPageTabsProps) => {
  return (
    <div style={{ marginTop: "30px", marginBottom: "50px" }}>
      {tabs?.length > 0 && (
        <Tabs
          tabs={tabs}
          logoLink="/icons/nextgolftour_logo_icon.svg"
          logoTitle="Order of Merit"
          pageSlug="order-of-merit"
        />
      )}
      {children}
    </div>
  );
};

export default OrderOfMeritPageTabs;
